import { resolveFormValidationError, setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Form, Input, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useUserDeleteUserTotpDevice } from "../../../../common/api/queries";
import { ModalSizes } from "../../../../common/constants";
import { AgentUserProfile, ClientUserProfile, DeleteUserTotpDevice, UserTotpDevice } from "../../types";

interface Props {
  user: AgentUserProfile | ClientUserProfile;
  totpDevice?: UserTotpDevice;
  onFormCancel: () => void;
}

export const DeleteUserTotpDeviceForm = ({ user, totpDevice, onFormCancel }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<DeleteUserTotpDevice>();

  const deleteUserTotpDevice = useUserDeleteUserTotpDevice();

  const handleFormSubmit = () => {
    if (totpDevice) {
      form
        .validateFields()
        .then((values) => {
          deleteUserTotpDevice.mutate(
            { id1: user.id, id2: totpDevice.id, object: values },
            {
              onSuccess: onFormCancel,
              onError: (error) => setErrorsToForm(form, "user.totpDevice.attrs", error.violations),
            },
          );
        })
        .catch(resolveFormValidationError);
    }
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={!!totpDevice}
      title={t("user.totpDevice.titles.delete")}
      okText={t("common.delete")}
      cancelText={t("common.cancel")}
      confirmLoading={deleteUserTotpDevice.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onFormCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="deleteUserTotpDeviceForm">
        <Form.Item name="password" label={t("user.totpDevice.attrs.password")} rules={[validations.notBlank]}>
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};
